module.exports = __webpack_public_path__ + "static/media/Livre8.5960e9fb.png";